import {Component, ViewEncapsulation} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcp-categories-modal',
  templateUrl: './categories-modal.component.html',
  styleUrls: ['./categories-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CategoriesModalComponent {

  constructor(private modalService: NgbModal) {
  }

  /**
   * Opens the content in a modal.
   *
   * @param content to display in modal.
   */
  open(content: any) {
    this.modalService.open(content, {windowClass: 'categories-modal'});
  }
}
